export default {
  name: 'EcsBusinessProcessSelectionMixin',
  props: {
    itemValue: {
      type: String,
      required: true
    },
    itemText: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    filterMediaType: {
      type: String,
      default: null
    },
    onValueChange: {
      type: Function,
      required: true
    },
    value: {
      type: [String, Array],
      required: true
    }
  },
  computed: {
    availableBusinessProcesses() {
      if (this.filterMediaType) {
        return this.items.filter(bp => bp.outgoingMediaTypes.includes(this.filterMediaType));
      }
      return this.items;
    }
  }
};
